<!-- 导师详情 -->
<template>
  <div class="mentor-detail">
    <div class="mentor-detail-container">
      <div class="mentor-detail-left">
        <img :src="appDetail.mentorAvaurl"
             alt="头像">
      </div>
      <div class="mentor-detail-right">
        <div class="mentor-detail-info">
          <h1>{{appDetail.mentorType}}导师 - {{appDetail.mentorName}}</h1>
          <ul>
            <li>
              <p>辅导开始时间：{{appDetail.menteeResultTimeStr}}（{{appDetail.menteeZone | zoneTitleMap}}）</p>
              <div>预计讨论时间：{{appDetail.predictTime}}</div>
            </li>
            <li>
              <p>讨论主题：{{appDetail.title}}</p>
              <div>
                <span v-if="isPackageId && (appDetail.module === 'MODULE_1')">PS Brainstorming</span>
                <span v-else>{{appDetail.module | appModuleTitleMap }}</span>
              </div>
            </li>
            <li v-show="isShow"></li>
            <template v-if="isShow">
              <li v-for="(item, index) in trackInfo"
                  :key="index">
                <template v-if="item.resultTime">
                  <p>{{index+1}}. {{item.createRole === "MENTOR"? '导师':'学生' }} 确认时间</p>
                  <div>
                    {{item.resultTimeStr}}
                    <span>({{ item.menteeZone | zoneTitleMap}})</span>
                  </div>
                </template>
                <template v-else>
                  <p>{{index+1}}. {{item.createRole === 'MENTOR'? '导师':'学生' }} 期望辅导时间
                    <span>({{ item.menteeZone | zoneTitleMap}})</span>
                  <div v-for="(time, timeIndex) in item.content"
                       :key="timeIndex"> {{time.minTimeStr}} - {{time.maxTimeStr}}{{timeIndex===0?' (优先)':''}}</div>
                </template>
              </li>
              <!-- <li>
                <p>3. 学生确认时间</p>
                <div>2019-03-22 16:00（北京时间）</div>
              </li> -->
            </template>
            <li :class="[isShow?'dis-64':'']">
              <span @click="isShow = !isShow"
                    class="click-detail">{{isShow?'收起详情':'展开详情'}}</span>
            </li>
          </ul>
        </div>
        <!-- orange red green -->
        <div class="mentor-detail-prompt"
             :class="appDetail.statu|todoStatusColorMap">
          <span>{{ appDetail.statu|todoStatusTitleMap }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// api
import { getAppTrackList } from '@/api/appointment'
// images
import logo from '@/assets/images/home/Chrome.svg'
export default {
  name: '',
  props: ['appDetail', 'id', 'isPackageId'],
  components: {},
  data () {
    return {
      logo,
      isShow: false,
      trackInfo: []
    }
  },
  computed: {},
  mounted () {
    this.getAppTrackList()
  },
  methods: {
    getAppTrackList () {
      getAppTrackList({
        id: this.id
      }).then(res => {
        this.trackInfo = res.data.model
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
